import { SendHorizonal } from 'lucide-react';

import { Button } from '@/components/button';
import { Text } from '@/components/text';
import { getTotalRate } from '@/lib/models/rates/get-total-rate';
import { SpotRateModel } from '@/lib/models/rates/types';
import { formatPrice } from '@/utils/format';
import { tv } from '@/utils/styles';

interface RatesSpotBreakdownProps {
  rate: SpotRateModel;
}

const RatesSpotBreakdown = ({ rate }: RatesSpotBreakdownProps) => {
  const totalRate = getTotalRate(rate);

  const { dl, dt, dd, separator, total, legalText, legalList } = styles();

  return (
    <div>
      <span className={separator()} />
      <div>
        {(rate.fromFees || []).map((fee) => {
          return (
            <dl key={fee.abbr} className={dl()}>
              <dt className={dt()}>{fee.title}</dt>
              <dd className={dd()}>{formatPrice(Math.round(fee.cost.value), fee.cost.currency, 1)}</dd>
            </dl>
          );
        })}
        <span className={separator()} />
        {(rate.toFees || [])?.map((fee) => {
          return (
            <dl key={fee.abbr} className={dl()}>
              <dt className={dt()}>{fee.title}</dt>
              <dd className={dd()}>{formatPrice(Math.round(fee.cost.value), fee.cost.currency, 1)}</dd>
            </dl>
          );
        })}
        <span className={separator()} />
        <dl className={dl()}>
          <dt className={dt()}>Ocean freight (1 x TEU)</dt>
          <dd className={dd()}>{formatPrice(Math.round(rate.pricing.value), rate.pricing.currency, 1)}</dd>
        </dl>
      </div>
      <span className={separator()} />
      <div className={total()}>
        <Button iconRight={<SendHorizonal className="size-4" />}>Enquire</Button>
        <div>
          <Text variant="secondary" className="m-0 text-grey-700">
            Estimated total
          </Text>
          <Text className="m-0 text-base font-semibold">
            {formatPrice(Math.round(totalRate.value), totalRate.currency, 1)}
          </Text>
        </div>
      </div>
      <div className={legalText()}>
        <Text className="mb-0">All rates shown are per TEU (Port-to-Port) and do not include the following:</Text>
        <ul className={legalList()}>
          <li>Local port/customs fees or any other unforeseen or additional charges</li>
          <li>IMO or OWS surcharges (where applicable)</li>
          <li>Standard freetime in POL or POD on storage/demurrage/detention and electricity charges (for reefers)</li>
        </ul>
      </div>
    </div>
  );
};

const styles = tv({
  slots: {
    dl: 'm-0 mb-2 flex w-full text-baseSm leading-snug last-of-type:mb-0',
    dt: 'm-0 flex-1 p-0 text-grey-700',
    dd: 'm-0 p-0 pl-1 text-right font-medium',
    total: 'flex-start flex justify-between pt-2 text-right',
    separator: 'my-2.5 block border-t border-dashed border-grey-300',
    legalText: 'm-0 mt-4 text-sm text-grey-500',
    legalList: 'm-0 list-disc pl-4',
  },
});

export { RatesSpotBreakdown };
